/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Bland_Alert_Lynx_TwirlInputs */

const fr_bland_alert_lynx_twirl = /** @type {(inputs: Bland_Alert_Lynx_TwirlInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Aucune instruction renseignée`)
};

/**

* @param {Bland_Alert_Lynx_TwirlInputs} inputs
* @param {{ locale?: "fr" }} options
* @returns {LocalizedString}
*/
export const bland_alert_lynx_twirl = /** @type {((inputs?: Bland_Alert_Lynx_TwirlInputs, options?: { locale?: "fr" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Bland_Alert_Lynx_TwirlInputs, { locale?: "fr" }, {}>} */ ((inputs = {}, options = {}) => {
	experimentalStaticLocale ?? options.locale ?? getLocale()
	return fr_bland_alert_lynx_twirl(inputs)
});